import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';

let sceneTextEnterM: any = null,
    sceneTextLeaveM: any = null;

export default function SectionA7() {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionA7');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterM) {
                    AniContainer.removeScene(sceneTextEnterM);
                    sceneTextEnterM = null;
                }
                if (sceneTextLeaveM) {
                    AniContainer.removeScene(sceneTextLeaveM);
                    sceneTextLeaveM = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterM = AniContainer.create({
                    triggerElement: '.page-sectionA7 .sticky-box',
                    triggerHook: 1,
                    offset: startH, //isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    duration: 200, //1500, //window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterM) {
                    AniContainer.removeScene(sceneTextEnterM);
                    sceneTextEnterM = null;
                }
                if (sceneTextLeaveM) {
                    AniContainer.removeScene(sceneTextLeaveM);
                    sceneTextLeaveM = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <div className={`page-sectionA7 ${styles.SectionA7}`}>
            <div className={`sticky-box${textEnter ? ' textEnter' : ''}`}>
                <div className="img-box">
                    <div className="title-box">
                        <h2 className="title">{t('title')}</h2>
                        <h2 className="desc">{t('desc')}</h2>
                    </div>
                    <EcoImg
                        className="product-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1750910435266/pc_covers%20every%20appliance.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1750910541368/m_covers%20every%20appliance.png"
                    />
                    <div className="mask"></div>
                </div>
            </div>
        </div>
    );
}
